import React, { useEffect, useMemo, useState } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import PndApi from '../../../../utils/pnd/PndRestApi';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import { Tooltip, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { showNotification } from 'src/shared/components/Notification';
import RiderLocationMapModal from '../../RiderLocationHistory/View/components/RiderLocationMapModal';
import InfoIcon from '@mui/icons-material/Info';
import RiderWiseOrderDetails from './components/RiderWiseOrderDetails';
import {
  ERROR_MESSAGES,
  ALL_RIDER,
  RIDER_ASSIGNED,
  RIDER_ON_BREAK,
  RIDER_PICKED_UP,
  RIDER_DEPARTED,
  RIDER_FREED,
  RIDER_BUSY,
  RIDER_RETURNED,
  RIDER_UNDELIVERED,
  RIDER_RETURN_FREED,
  RIDER_UNAVAILABLE
} from 'src/utils/pnd/PndConstants';
import { useHistory } from 'react-router-dom';
import RadioSelectTable from 'src/shared/components/table/RadioSelectTable';
import PageHeader from 'src/shared/components/layout/PageHeader';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';

const UserIndex = () => {
  const [selectedRider, setSelectedRider] = useState(null);
  const [originalRiders, setOriginalRiders] = useState([]);
  const [statusFilter, setStatusFilter] = useState(ALL_RIDER);

  useEffect(() => {
    getAllRidersDetails();
  }, [])

  const [reactTableData, setReactTableData] = useState({ tableHeaderData: [], tableRowsData: [] });
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [data, setData] = useState(null);
  const [isGoogleMapView, setGoogleMapView] = useState(null);
  const [isViewOrderPopup, setViewOrderPopup] = useState(false);
  const [isRiderId, setRiderId] = useState(null);
  const history = useHistory();

  const statusOptions = useMemo(() => [
    { id: ALL_RIDER, name: 'All' },
    { id: RIDER_ASSIGNED, name: 'Assigned' },
    { id: RIDER_ON_BREAK, name: 'On Break' },
    { id: RIDER_PICKED_UP, name: 'Picked Up' },
    { id: RIDER_DEPARTED, name: 'Departed' },
    { id: RIDER_FREED, name: 'Delivered Freed' },
    { id: RIDER_BUSY, name: 'Busy' },
    { id: RIDER_RETURNED, name: 'Returned at the Hub' },
    { id: RIDER_UNDELIVERED, name: 'Undelivered' },
    { id: RIDER_RETURN_FREED, name: 'Return Freed at the Hub' },
    { id: RIDER_UNAVAILABLE, name: 'Unavailable' }
  ], []);

  const filterRiders = (statusVal, ridersList) => {
    let filtered = ridersList;
    if (Number(statusVal) !== ALL_RIDER) {
      if (Number(statusVal) === RIDER_ON_BREAK) {
        filtered = ridersList.filter(r => r.isRiderOnBreak || Number(r.riderStatusId) === RIDER_ON_BREAK);
      } else {
        filtered = ridersList.filter(r => Number(r.riderStatusId) === Number(statusVal));
      }
    }
    setReactTableData(prev => ({
      ...prev,
      tableRowsData: filtered
    }));

    if (selectedRider && !filtered.some(r => r.riderId === selectedRider.riderId)) {
      setSelectedRider(filtered.length > 0 ? filtered[0] : null);
    }
  };

  const getAllRidersDetails = async () => {
    try {
      setLoading(true);
      const response = await PndApi.FindRiderLiveGridViewData();
      if (response.status === 200 && response.data.status === 200) {
        const ridersList = response.data.data || [];
        setOriginalRiders(ridersList);

        let filtered = ridersList;
        if (Number(statusFilter) !== ALL_RIDER) {
          if (Number(statusFilter) === RIDER_ON_BREAK) {
            filtered = ridersList.filter(r => r.isRiderOnBreak || Number(r.riderStatusId) === RIDER_ON_BREAK);
          } else {
            filtered = ridersList.filter(r => Number(r.riderStatusId) === Number(statusFilter));
          }
        }

        setReactTableData({ tableHeaderData: riderColumns, tableRowsData: filtered });

        if (filtered.length > 0) {
          if (!selectedRider || !filtered.some(r => r.riderId === selectedRider.riderId)) {
            setSelectedRider(filtered[0]);
          }
        } else {
          setSelectedRider(null);
        }
      } else if (response.status === 200 && response.data.status === 204) {
        setNoRecordFound(true);
        setOriginalRiders([]);
        setReactTableData({ tableHeaderData: riderColumns, tableRowsData: [] });
        setSelectedRider(null);
      }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };
  const openMap = async (event) => {
    if (event) {
      let Obj = {
        "latitude": event?.latitude,
        "longitude": event?.longitude,
        "plateNo": event?.plateNo,
        "riderName": event?.riderName,
        "location": event?.location,
        "riderStatus": event?.riderStatus,
        "storeName": event?.storeName
      }
      setData(Obj);
      setGoogleMapView(true);

    }
  }

  const viewOrderDetails = async (event) => {
    if (event?.riderId) {
      try {
        setLoading(true);
        const response = await PndApi.GetRiderWiseActiveOrderList(event.riderId);
        if (response.status === 204 || (response.status === 200 && response.data?.status === 204)) {
          showNotification(
            "theme-light",
            "ltr",
            "Warning",
            "No order",
          );
        } else if (response.status === 200 && response.data?.status === 200) {
          history.push('/web_app/pnd_order/rider-wise-order/view/' + event?.riderId);
        } else {
          showNotification(
            "theme-light",
            "ltr",
            `SuccessCode: ${response.data?.status || response.status}`,
            `Message:${response.data?.message || 'Failed to fetch order details'}`,
          );
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: 500`,
          ERROR_MESSAGES.tryCatchError,
        );
      } finally {
        setLoading(false);
      }
    }
  };


  const riderColumns = useMemo(() => [
    {
      key: 'action', header: 'Action', sortable: false, render: (_, row) => (
        <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
          <Tooltip title="Click here to view order details">
            <InfoIcon
              style={{ cursor: 'pointer', color: 'blue', fontSize: '24px', marginRight: '4px' }}
              onClick={(e) => {
                e.stopPropagation();
                viewOrderDetails(row);
              }}
            />
          </Tooltip>
          <Tooltip title="Click here to open the current location of the rider in Google Map">
            <AddLocationAltIcon
              style={{ cursor: 'pointer', color: 'green', fontSize: '24px', marginRight: '4px' }}
              onClick={(e) => {
                e.stopPropagation();
                openMap(row);
              }}
            />
          </Tooltip>
        </div>
      )
    },
    { key: 'riderName', header: 'Rider Name', sortable: true },
    { key: 'riderStatus', header: 'Status', sortable: true },
  ], []);



  return (

    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>
        <PageHeader
          icon={<DirectionsBikeIcon fontSize="large" />}
          title="Active Rider Details"
          subtitle="View, filter and manage rider information in a sleek dashboard."
          gradient="linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
        />
        <Row style={{ marginTop: '20px' }}>
          {/* Left Panel: Master List with essential details */}
          <Col md={7} lg={7}>
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel id="rider-status-filter-label">Rider Status</InputLabel>
                <Select
                  labelId="rider-status-filter-label"
                  value={statusFilter}
                  label="Rider Status"
                  onChange={(e) => {
                    const statusVal = e.target.value;
                    setStatusFilter(statusVal);
                    filterRiders(statusVal, originalRiders);
                  }}
                  sx={{ borderRadius: 2, bgcolor: 'white' }}
                >
                  {statusOptions.map(status => (
                    <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <RadioSelectTable
              rows={reactTableData?.tableRowsData || []}
              columns={riderColumns}
              rowKey="riderId"
              selectedKey={selectedRider?.riderId}
              onSelect={setSelectedRider}
              searchKeys={['riderName', 'riderStatus']}
              searchPlaceholder="Search riders..."
              pageSizes={[5, 10, 20]}
            />
          </Col>

          {/* Right Panel: Sleek Detail Card */}
          <Col md={5} lg={5}>
            {selectedRider ? (
              <Card style={{
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
                minHeight: '520px',
                background: '#ffffff',
                overflow: 'hidden'
              }}>
                {/* Header Banner */}
                <div style={{ background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', padding: '24px 20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <h4 style={{ margin: 0, fontWeight: 800, fontSize: '1.2rem', color: '#ffffff' }}>{selectedRider.riderName}</h4>
                      <span style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.85)' }}>{selectedRider.riderUserName}</span>
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                      <span className={`badge ${selectedRider.riderStatusId === 3 || selectedRider.riderStatusId === 9 ? 'bg-success' : selectedRider.riderStatusId === 6 ? 'bg-primary' : 'bg-danger'}`}
                        style={{ fontSize: '0.75rem', fontWeight: 700 }}>
                        {selectedRider.riderStatus}
                      </span>
                      {selectedRider.riderRoasterStatusName && (
                        <span className="badge bg-light text-dark" style={{ fontSize: '0.75rem', fontWeight: 700 }}>
                          {selectedRider.riderRoasterStatusName}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Details Body */}
                <CardBody style={{ padding: '20px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {/* Profile */}
                    <div>
                      <h6 className="text-muted text-uppercase fw-bold mb-2" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                        Rider Profile
                      </h6>
                      <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '12px 14px', border: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Username:</span>
                          <span className="fw-bold small text-dark">{selectedRider.riderUserName || '—'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Mobile No:</span>
                          <span className="fw-bold small text-dark">{selectedRider.mobileNo || '—'}</span>
                        </div>
                      </div>
                    </div>

                    {/* Vehicle Details */}
                    <div>
                      <h6 className="text-muted text-uppercase fw-bold mb-2" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                        Vehicle Details
                      </h6>
                      <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '12px 14px', border: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Vehicle No.:</span>
                          <span className="fw-bold small text-dark">{selectedRider.plateNo || '—'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Vehicle Mode:</span>
                          <span className="fw-bold small text-dark">{selectedRider.vehicleMode || '—'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Vehicle Speed:</span>
                          <span className="fw-bold small text-dark">{selectedRider.speed !== undefined ? `${selectedRider.speed} km/h` : '—'}</span>
                        </div>
                      </div>
                    </div>

                    {/* Duty Status & Orders */}
                    <div>
                      <h6 className="text-muted text-uppercase fw-bold mb-2" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                        Duty Status & Orders
                      </h6>
                      <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '12px 14px', border: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Duty Status:</span>
                          <span className="fw-bold small text-dark">{selectedRider.riderRoasterStatusName || '—'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Pending Orders:</span>
                          <span className="fw-bold small text-dark">{selectedRider.orderCount !== undefined ? selectedRider.orderCount : '—'}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            ) : (
              <Card style={{ borderRadius: '12px', border: '1px solid #e2e8f0', padding: '40px', textAlign: 'center', minHeight: '520px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <p className="text-muted mb-0">Select a rider from the list to view their detailed information.</p>
              </Card>
            )}
          </Col>
        </Row>
        {isNoRecordFound && <SnackbarContent message={'No Record Found'} />}
        {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
        {isGoogleMapView && (
          <RiderLocationMapModal
            modalShow={isGoogleMapView}
            setModalShow={setGoogleMapView}
            data={data}
          />
        )}
        {isViewOrderPopup && isRiderId && !isNoRecordFound && (
          <RiderWiseOrderDetails
            isRiderId={isRiderId}
            modalShow={isViewOrderPopup}
            setModalShow={setViewOrderPopup}
            reactTableData={reactTableData}
          />
        )}
      </Container>
    </Box>
  );
};

export default UserIndex;